import { computed, Injectable, signal } from '@angular/core';
import type {
  SidebarListFooterAction,
  SidebarListItem,
  SidebarListVariant,
} from './sidebar-list.interfaces';

export interface SidebarListViewItem extends SidebarListItem {
  sourceItem: SidebarListItem;
  ariaSelected: boolean;
  showAvatar: boolean;
  showSelectedIcon: boolean;
  showSpacer: boolean;
}

@Injectable()
export class SidebarListStore {
  readonly items = signal<SidebarListItem[]>([]);
  readonly title = signal<string | undefined>(undefined);
  readonly createLabel = signal<string | undefined>(undefined);
  readonly footerActions = signal<SidebarListFooterAction[]>([]);
  readonly variant = signal<SidebarListVariant>('avatar');
  readonly showCreateInHeader = signal(false);
  readonly showCreate = signal(false);
  readonly showSelectionIndicator = signal(true);

  readonly hasSelectedItem = computed(() => this.items().some(item => item.selected));
  readonly resolvedVariant = computed<SidebarListVariant>(() => this.variant());
  readonly showItemAvatar = computed(() => this.resolvedVariant() !== 'compact');
  readonly showItemCheckmarks = computed(
    () => this.showSelectionIndicator() && this.resolvedVariant() !== 'inline-avatar'
  );
  readonly headerTitle = computed(() => this.title());
  readonly headerCreateLabel = computed(() =>
    this.showCreate() && this.showCreateInHeader() ? this.createLabel() : undefined
  );
  readonly showHeader = computed(() => !!this.headerTitle() || !!this.headerCreateLabel());
  readonly viewItems = computed<SidebarListViewItem[]>(() => {
    const showAvatar = this.showItemAvatar();
    const showCheckmarks = this.showItemCheckmarks();

    return this.items().map(item => ({
      ...item,
      sourceItem: item,
      ariaSelected: item.selected ?? false,
      showAvatar,
      showSelectedIcon: showCheckmarks && !!item.selected,
      showSpacer: showCheckmarks && !item.selected,
    }));
  });
}
